<template>
  <el-container class="playing">
    <SidebarMenus />
    <el-container class="main-container">
      <el-header class="header">
        <div class="header-content">
          <img
            src="../../../assets/logo-text.png"
            alt="OxpeckerLogo"
            class="logo"
          />
          <div class="user-info">
            <img
              src="../../../assets/codeScan/account-circle.png"
              alt="User Icon"
              class="user-icon"
            />
            <span class="username">CHRIS</span>
          </div>
        </div>
      </el-header>
      <el-main class="main-content">
        <div class="content-header"></div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'PlayIng',
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss">
.playing {
  width: 100%;
  height: 100vh;
  display: flex;
  // background-color: #f5f5f5;
  margin: 10px 0px;
  border-radius: 10px;
  height: calc(100vh - 45px);

  .main-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 70px;
    left: 90px;
    width: 95.2%;
    height: calc(100vh - 96px);
  }

  .logo {
    width: 150px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 30px;
  }

  .user-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    right: 10px;
  }

  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;
    line-height: 54px;

    img {
      position: relative;
      top: 0;
    }

    h2 {
      font-size: 20px;
    }

    .el-breadcrumb {
      font-size: 17px;
      margin: 0px 15px;
      position: relative;
      top: 2px;
      right: 37%;
    }

    .el-dropdown-link {
      background-color: #fff;
      border-color: #101010;
      color: #000000;
      height: 30px;
      padding: 5px 20px;
    }
  }
}
</style>